import React from 'react';

import StrapiImageSource from './StrapiImageSource';
import { IStrapiMedia, IStrapiMediaFormatSizes } from 'types';

interface IProps {
  image: IStrapiMedia;
  preferredSize?: IStrapiMediaFormatSizes;
  width?: number;
  [key: string]: unknown;
}

/**
 * Provides code for a single image based off IStrapiMedia. IF there's a preferred
 * size in IStrapiMediaFormatSizes that's specified, it will render that image.
 * Otherwise, it will just render the base url.
 * @param props
 */
const StrapiImage: React.FunctionComponent<IProps> = ({ image, preferredSize, ...rest }) => {
  return (
    <picture>
      {preferredSize && image.formats && image.formats[preferredSize] && (
        <StrapiImageSource image={image.formats[preferredSize]} />
      )}
      <StrapiImageSource image={image} />
      <img itemProp="image" src={image.url} alt={image.alternativeText || ''} {...rest} />
    </picture>
  );
};

export default StrapiImage;
